/*
 * @Description: 项目模块
 * @Version: 1.0
 * @Autor: steFan
 * @Date: 2020-03-17 09:39:58
 * @LastEditors: steFan
 * @LastEditTime: 2020-03-28 14:44:20
 */
import Vue from "vue";
import Router from "vue-router";
import Warp from "../pages/warp/warp"; //娱乐城
import HomeIndex from "../pages/homeIndex/homeIndex"; //娱乐城
import common from '../utils/common'

Vue.use(Router);
/** 
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch((error) => error);
};
const routers = [{
    path: "/",
    name: "warp",
    component: Warp,
    redirect: "/home",
    children: [{
            path: "/home",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: HomeIndex,
        },
        {
            path: "/agent",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/agent/agent"),
        },
        {
            path: "/agentDetail",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/agent/agentDetail"),
        },
        {
            path: "/lottery",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/lottery/lottery"),
        },
        {
            path: "/live",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/live/live"),
        },
        {
            path: "/egame",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/egame/egame"),
        },
        {
            path: "/fish",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/fish/fish"),
        },
        // {
        //     path: "/lottery",
        //     meta: {
        //         requireAuth: true, // 彩票
        //         title: window.projectName,
        //     },
        //     component: () =>
        //         import ("@/pages/lottery/lottery"),
        // },
        {
            path: "/chess",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/chess/chess"),
        },
        {
            path: "/sport",
            meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的  (登录拦截) putInGr
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/sport/sport"),
        },

        {
            path: "/register",
            meta: {
                requireAuth: true,
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/login/register"),
        },
        {
            path: "/app",
            meta: {
                requireAuth: true,
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/download/download"),
        },
        {
            path: "/help",
            meta: {
                requireAuth: true,
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/help/help"),
        },
        // {
        //     path: "/prize",
        //     meta: {
        //         requireAuth: true,
        //         title: window.projectName,
        //     },
        //     component: () =>
        //         import ("@/pages/prize/prizeHistory"),
        // },
        {
            path: "/discount",
            meta: {
                requireAuth: true,
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/discount/Discount"),
        },
        // {
        //     path: "/cooperation",
        //     meta: {
        //         requireAuth: true,
        //         title: window.projectName,
        //     },
        //     component: () =>
        //         import ("@/pages/cooperation/cooperation")
        // },
        {
            path: "/my",
            name: "my",
            component: () =>
                import ("@/pages/my/My.vue"),
            redirect: "/my/info",
            children: [{
                    path: "/my/info",
                    name: "个人资料",
                    redirect: "/my/info/basic",
                    component: () =>
                        import ("@/pages/my/info/Info.vue"),
                    children: [{
                            path: "/my/info/basic",
                            name: "基本信息",
                            component: () =>
                                import ("@/pages/my/info/Basic.vue"),
                        },
                        {
                            path: "/my/info/bankCard",
                            name: "银行卡管理",
                            component: () =>
                                import ("@/pages/my/info/BankCard.vue"),
                        },
                        {
                            path: "/my/info/data",
                            name: "账户设置",
                            component: () =>
                                import ("@/pages/my/info/Data.vue"),
                        },
                        {
                            path: "/my/info/account",
                            name: "完善资料",
                            component: () =>
                                import ("@/pages/my/info/Account.vue"),
                        },
                    ],
                },
                {
                    path: "/my/security",
                    name: "安全管理",
                    redirect: "/my/security/verification",
                    component: () =>
                        import ("@/pages/my/security/Security.vue"),
                    children: [{
                            path: "/my/security/verification",
                            name: "安全验证",
                            component: () =>
                                import ("@/pages/my/security/Verification.vue"),
                        },
                        {
                            path: "/my/security/capital",
                            name: "资金密码",
                            component: () =>
                                import ("@/pages/my/security/Capital.vue"),
                        },
                        {
                            path: "/my/security/login",
                            name: "登录密码",
                            component: () =>
                                import ("@/pages/my/security/Login.vue"),
                        },
                        {
                            path: "/my/security/device",
                            name: "设备管理",
                            component: () =>
                                import ("@/pages/my/security/Device.vue"),
                        },
                    ],
                },

                                {
                                    path: "/my/lotteryGold",
                                    name: "彩金管理",
                                    component: () =>
                                        import ("@/pages/my/lotteryGold/lotteryGold.vue"),
                                },

                               {
                                   path: "/my/finance",
                                   name: "财务中心",
                                   redirect: "/my/finance/deposit",
                                   component: () =>
                                       import ("@/pages/my/finance/Finance.vue"),
                                   children: [{
                                           path: "/my/finance/deposit",
                                           name: "会员存款",
                                           component: () =>
                                               import ("@/pages/my/finance/Deposit.vue"),
                                       },
                                       {
                                           path: "/my/finance/withdraw",
                                           name: "会员提款",
                                           component: () =>
                                               import ("@/pages/my/finance/Withdraw.vue"),
                                       },
                                       {
                                           path: "/my/finance/transfer",
                                           name: "户内转账",
                                           component: () =>
                                               import ("@/pages/my/finance/Transfer.vue"),
                                       },
                                   ],
                               },

                               {
                                   path: "/my/tradingRecord",
                                   name: "tradingRecord",
                                   component: () =>
                                       import ("@/pages/my/customer/tradingRecord.vue"),
                               },

                               {
                                   path: "/my/gameRecord",
                                   name: "gameRecord",
                                   component: () =>
                                       import ("@/pages/my/customer/gameRecord.vue"),
                               },

                               {
                                   path: "/my/activationRecord",
                                   name: "activationRecord",
                                   component: () =>
                                       import ("@/pages/my/customer/activationRecord.vue"),
                               },
                               {
                                   path: "/my/interest",
                                   name: "interest",
                                   component: () =>
                                       import ("@/pages/my/customer/interest.vue"),
                               },
                               {
                                   path: "/my/highRebate",
                                   name: "highRebate",
                                   component: () =>
                                       import ("@/pages/my/customer/highRebate.vue"),
                               },

                               {
                                   path: "/my/service",
                                   name: "公告信息",
                                   redirect: "/my/service/notice",
                                   component: () =>
                                       import ("@/pages/my/service/Service.vue"),
                                   children: [{
                                           path: "/my/service/notice",
                                           name: "公告",
                                           component: () =>
                                               import ("@/pages/my/service/Notice.vue"),
                                       },
                                       {
                                           path: "/my/service/mail",
                                           name: "站内信",
                                           component: () =>
                                               import ("@/pages/my/service/Mail.vue"),
                                       },
                                   ],
                               },
                               {
                                   path: "/my/discount",
                                   name: "自助优惠",
                                   component: () =>
                                       import ("@/pages/my/discount/Discount.vue"),

                               },
                               {
                                   path: "/my/discount/credentials",
                                   name: "信息认证",
                                   component: () =>
                                       import ("@/pages/my/discount/Credentials.vue"),
                               },
                               // {
                               //     path: "/my/discount/codeWash",
                               //     name: "洗码积分",
                               //     component: () =>
                               //         import ("@/pages/my/discount/CodeWash.vue"),
                               // },
/*                               {
                                   path: "/my/discount/week",
                                   name: "周勤奖励",
                                   component: () =>
                                       import ("@/pages/my/discount/Week.vue"),
                               },*/
                               {
                                   path: "/my/discount/lucky",
                                   name: "幸运注单",
                                   component: () =>
                                       import ("@/pages/my/discount/Lucky.vue"),
                               },
/*                               {
                                   path: "/my/discount/anniversary",
                                   name: "周年礼金",
                                   component: () =>
                                       import ("@/pages/my/discount/Anniversary.vue"),
                               },*/
                               {
                                   path: "/my/discount/reward",
                                   name: "棋牌奖励",
                                   component: () =>
                                       import ("@/pages/my/discount/Reward.vue"),
                               },
                               {
                                   path: "/my/discount/rescue",
                                   name: "棋牌救援",
                                   component: () =>
                                       import ("@/pages/my/discount/Rescue.vue"),
                               },
                               {
                                   path: "/my/discount/manyTimes",
                                   name: "千倍万倍",
                                   component: () =>
                                       import ("@/pages/my/discount/ManyTimes.vue"),
                               },
/*                {
                    path: "/my/discount/feedback",
                    name: "亿元回馈",
                    component: () =>
                        import ("@/pages/my/discount/Feedback.vue"),
                },*/
            ],
        },
        {
            path: "/domain",
            meta: {
                requireAuth: true,
                title: window.projectName,
            },
            component: () =>
                import ("@/pages/domain/Domain.vue"),
        }
    ],
},
{
    path: '/bankRecharge',
    name: 'bankRecharge',
    component: () => import('../pages/bankRecharge/bankRecharge.vue'),
},
{
    path: '/iplimit',
    name: 'iplimit',
    component: () => import('@/pages/iplimit/iplimit'),
},   
{
    path: "/index",
    name: 'index',
    component: () => import('@/pages/index/index'),
},];
// 页面刷新时，重新赋值token
// if (window.localStorage.getItem('token')) {
//     // let token = localStorage.getItem("token");
//     // store.commit(types.LOGIN, token)
// };
const router = new Router({
    // mode: 'hash',
    mode: "history",
    routes: routers,
});
//(登录拦截)
// * to: Route: 即将要进入的目标 路由对象
// * from: Route: 当前导航正要离开的路由
// * next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
// * next(): 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed （确认的）。
// * next(false): 中断当前的导航。如果浏览器的 URL 改变了（可能是用户手动或者浏览器后退按钮），那么 URL 地址会重置到 from 路由对应的地址。
// * next(‘/’) 或者 next({ path: ‘/’ }): 跳转到一个不同的地址。当前的导航被中断，然后进行一个新的导航。
let isLoading = null;
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    if (window.mask && !common.isLogin() && to.fullPath != '/index') {
        console.log(to)
        next("/index")
        return
    }
    // if (to.matched.length === 0) { //如果未匹配到路由
    // 	next('/'); //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
    // } else {
    // 	next(); //如果匹配到正确跳转
    // }
    if (to.matched.some((r) => r.meta.requireAuth)) {
        isLoading = true;
        let token = localStorage.getItem("set_user");
        let restraint = sessionStorage.getItem("restraint");
        if (!restraint || restraint === "false") {
            next();
        } else {
            next("/restraint");
        }
    } else {
        next();
    }
});
// router.beforeEach(() => {
// 	isLoading = false
// })
export default router;